export function comparableDocumentCitations(citations = []) {
  return [
    ...new Map(
      citations
        .filter(
          (item) =>
            item.resolution_status === "resolved" &&
            item.citation_type !== "section" &&
            item.resolved_target_id &&
            item.resolved_target_expression_id &&
            item.resolved_target_work_id,
        )
        .map((item) => [item.resolved_target_id, item]),
    ).values(),
  ];
}

export function citationsForSegment(citations = [], sequence) {
  if (sequence == null) return [];
  return comparableDocumentCitations(citations).filter(
    (item) =>
      Number(item.source_segment_sequence) === Number(sequence),
  );
}
